import WebApp from '@twa-dev/sdk';
import { isIOS, isMacOs, isSafari } from 'react-device-detect';

import { UIKit } from '@/shared/stores/app-store/types';

import { isTMA } from '../telegram/is-tma';

export const getUIKit = (): UIKit => {
  if (!isTMA()) {
    return isIOS || isSafari || isMacOs ? UIKit.APPLE : UIKit.MATERIAL;
  }

  if (['macos', 'ios'].includes(WebApp.platform)) {
    return UIKit.APPLE;
  }

  return UIKit.MATERIAL;
};
